import { Center } from '../ui/center'
import { Spinner } from '../ui/spinner'

export default function Loader() {
  return (
    <Center className="absolute inset-0 z-10" pointerEvents="none">
      <Spinner />
    </Center>
  )
}
